import { isActivityWithProgress } from "@app/secured/CourseDayPageV2";
import { ActivityStatus, ActivityType, cn, Icon } from "@cca/components";
import { ActivityProgressIcon } from "@core/componentsV2/ActivityProgressIcon";
import { ActivityDto } from "@core/typesV2";

export type DayItemIconProps = {
  activity: ActivityDto;
  isReview?: boolean;
  isActive?: boolean;
};

const DayItemIcon = ({ activity, isReview, isActive }: DayItemIconProps) => {
  const defaultIconClassName = "min-w-5 text-xl text-gray-600";
  const displayStatus =
    activity.progress?.isReset &&
    activity.progress.status === ActivityStatus.NotStarted
      ? ActivityStatus.InProgress
      : activity.progress?.status;

  if (activity.type !== ActivityType.Lesson) {
    return (
      <Icon
        className={cn(
          defaultIconClassName,
          isActivityWithProgress(activity) && !isReview
            ? {
                "text-blue-600": displayStatus === ActivityStatus.InProgress,
                "text-green-900": displayStatus === ActivityStatus.Completed,
              }
            : { "text-blue-600": isActive },
        )}
        type="clipboard-check"
      />
    );
  }

  if (isActivityWithProgress(activity) && !isReview) {
    return (
      <ActivityProgressIcon
        activityStatus={displayStatus || ActivityStatus.NotStarted}
        className="min-w-5 text-xl"
      />
    );
  }

  return (
    <Icon
      className={cn(defaultIconClassName, { "text-blue-600": isActive })}
      type="file-lines"
    />
  );
};

export default DayItemIcon;
